import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

export const RxLpChVoucherCircle: FC = () => (
  <div className="prose">
    <div className="flex size-28 items-center justify-center rounded-full bg-light-secondary-high text-center font-mono text-xs tablet:size-36 tablet:text-s">
      <span>
        <FormattedMessage id="chrx.voucher.circle.top.new" />
      </span>
    </div>
  </div>
)
